import { cloneElement } from "react";

interface CrudTableHeaderProps {
  title: string;
  count?: number;
  icon?: React.ReactElement;
}

export const CrudTableHeader: React.FC<CrudTableHeaderProps> = ({
  title,
  count,
  icon,
}) => {
  let iconWithClassName = null;
  if (icon) {
    const defaultIconClassName = "h-5 w-5 sm:h-6 sm:w-6 text-gray-800 flex-shrink-0";

    iconWithClassName = cloneElement(icon, {
      className: `${icon.props.className || ""} ${defaultIconClassName}`.trim(),
    });
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 border-b pb-4 gap-3">
      <div className="flex items-center space-x-2 min-w-0">
        {iconWithClassName}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800 truncate">
          {title}
        </h1>
      </div>

      {count !== undefined && count !== 0 && (
        <div className="flex-shrink-0">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs sm:text-sm font-medium bg-blue-50 text-blue-700 whitespace-nowrap">
            Total de {title.toLowerCase()}: {count}
          </span>
        </div>
      )}
    </div>
  );
};